import { t } from "./i18n.js";

/** Parse API error response and return a user-friendly message (handles backend code field). */
export async function getApiErrorMessage(res, locale = "en") {
  const data = await res.json().catch(() => ({}));
  const code = data.code || "";
  const msg = data.error || res.statusText;
  const byCode = {
    KEY_MISSING: t(locale, "error_key_missing"),
    KEY_EXISTS: t(locale, "error_key_exists"),
    KEY_MAY_BE_PULLED: t(locale, "error_key_may_be_pulled"),
    VALIDATION_ERROR: msg,
    STORE_UNAVAILABLE: t(locale, "error_store_unavailable"),
    STORE_ERROR: t(locale, "error_store_error")
  };
  return byCode[code] || msg || t(locale, "error_request_failed", { status: res.status });
}
